import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';

import PrimaryCta from 'base/components/PrimaryCta';
const flexProps = {
  width: '33%',
  flexBasis: '33%'
};
class ViewCart extends React.Component {
  static propTypes = {
    quantity: PropTypes.number,
    subtotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  render() {
    return (
      <PrimaryCta
        component={Link}
        to="/cart"
        fullWidth
        label={
          <Box display="flex" justifyContent="space-between" width="100%">
            <Box {...flexProps}>{this.props.quantity}</Box>
            <Box
              display="flex"
              justifyContent="center"
              {...flexProps}
              whiteSpace="nowrap"
            >
              View Cart
            </Box>
            <Box {...flexProps} display="flex" justifyContent="flex-end">
              ${this.props.subtotal}
            </Box>
          </Box>
        }
      />
    );
  }
}

export default ViewCart;
